// TODO: Move these types/enums to our constant/model directory
export type FilterLocalStorageGroup =
  | 'PostingPlanFilters'
  | 'MediaLibraryFilters'
  | 'PostEditorMediaLibraryFilters'
  | 'FindImagesFilters'
  | 'PostScheduleFilters'
  | 'PostLibraryFilters';
export type FilterLocalStorageKey =
  | PostingPlanFiltersEnum
  | MediaLibraryFiltersEnum
  | PostEditorMediaLibraryFiltersEnum
  | FindImagesFiltersEnum
  | PostScheduleFiltersEnum
  | PostLibraryFiltersEnum;

export type filterLocalStorageType = {
  group: FilterLocalStorageGroup;
  key: FilterLocalStorageKey;
};
export enum PostingPlanFiltersEnum {
  'categoryFilter' = 'categoryFilter',
  'profileFilter' = 'profileFilter',
  'showOutOfSeason' = 'showOutOfSeason'
}
export enum MediaLibraryFiltersEnum {
  'mediaTypeFilter' = 'mediaTypeFilter',
  'mediaOriginFilter' = 'mediaOriginFilter',
  'mediaProportionFilter' = 'mediaProportionFilter'
}
export enum PostEditorMediaLibraryFiltersEnum {
  'mediaTypeFilter' = 'mediaTypeFilter',
  'mediaOriginFilter' = 'mediaOriginFilter',
  'mediaProportionFilter' = 'mediaProportionFilter'
}
export enum FindImagesFiltersEnum {
  'findImagesTypeFilter' = 'findImagesTypeFilter',
  'findImagesSourceFilter' = 'findImagesSourceFilter',
  'findImagesProportionFilter' = 'findImagesProportionFilter'
}

export enum PostScheduleFiltersEnum {
  'postScheduleStatusFilter' = 'postScheduleStatusFilter',
  'postScheduleProfileFilter' = 'postScheduleProfileFilter',
  'postScheduleCategoryFilter' = 'postScheduleCategoryFilter',
  'postScheduleTimingFilter' = 'postScheduleTimingFilter',
  'postScheduleEvergreenFilter' = 'postScheduleEvergreenFilter',
  'postScheduleSourceFilter' = 'postScheduleSourceFilter',
  'postScheduleContentFilter' = 'postScheduleContentFilter'
}

export enum PostLibraryFiltersEnum {
  'postScheduleStatusFilter' = 'postScheduleStatusFilter',
  'postScheduleProfileFilter' = 'postScheduleProfileFilter',
  'postScheduleCategoryFilter' = 'postScheduleCategoryFilter'
}

type FilterEnumType =
  | typeof PostingPlanFiltersEnum
  | typeof MediaLibraryFiltersEnum
  | typeof PostEditorMediaLibraryFiltersEnum
  | typeof FindImagesFiltersEnum
  | typeof PostScheduleFiltersEnum
  | typeof PostLibraryFiltersEnum;

// map filters to enums
const FilterEnums: Record<FilterLocalStorageGroup, FilterEnumType> = {
  PostingPlanFilters: PostingPlanFiltersEnum,
  MediaLibraryFilters: MediaLibraryFiltersEnum,
  PostEditorMediaLibraryFilters: PostEditorMediaLibraryFiltersEnum,
  FindImagesFilters: FindImagesFiltersEnum,
  PostScheduleFilters: PostScheduleFiltersEnum,
  PostLibraryFilters: PostLibraryFiltersEnum
};

export const setFilterLocalStorage = (
  selectedWorkspaceId: string,
  filterGroup: FilterLocalStorageGroup,
  key: FilterLocalStorageKey,
  value: string
) => {
  const filters = localStorage.getItem(filterGroup);
  let filtersConfig;

  try {
    filtersConfig = JSON.parse(filters || '{}');
  } catch (e) {
    filtersConfig = [];
    // If the string is corrupt and cannot be parsed, we reset the string
    localStorage.setItem(filterGroup, '');
  }

  // If its empty or does not exist, we create it
  // If we have a config, but the key does not exist, we assume its corrupted and reset
  if (
    (selectedWorkspaceId && !filtersConfig[selectedWorkspaceId]) ||
    !Object.prototype.hasOwnProperty.call(filtersConfig[selectedWorkspaceId], key)
  ) {
    // Create our list of keyed values from the passed group type
    const filterSet: Record<string, string> = {};
    Object.keys(FilterEnums[filterGroup]).forEach(k => {
      filterSet[k] = '';
    });

    filtersConfig = {
      ...filtersConfig,
      [selectedWorkspaceId]: filterSet
    };
  }

  filtersConfig[selectedWorkspaceId][key] = value;

  localStorage.setItem(filterGroup, JSON.stringify(filtersConfig));
};

export const getFilterLocalStorageValue = (
  selectedWorkspaceId: string,
  filterGroup: FilterLocalStorageGroup,
  key: FilterLocalStorageKey
): string => {
  const filters = localStorage.getItem(filterGroup);
  let filtersConfig;

  try {
    filtersConfig = JSON.parse(filters || '{}');
  } catch (e) {
    filtersConfig = [];
    // If the string is corrupt and cannot be parsed, we reset the string
    localStorage.setItem(filterGroup, '');
  }

  let value = '';

  if (filtersConfig[selectedWorkspaceId] && filtersConfig[selectedWorkspaceId][key]) {
    value = filtersConfig[selectedWorkspaceId][key];
  }

  return value;
};

export const removeRefFilterValueFromFiltersLocalStorage = (
  filterGroups: filterLocalStorageType[],
  refValue: string,
  workspaceId: string
) => {
  filterGroups.forEach(filter => {
    const filterValue = getFilterLocalStorageValue(workspaceId, filter.group, filter.key);
    if (filterValue === refValue) {
      setFilterLocalStorage(workspaceId, filter.group, filter.key, '');
    }
  });
};
